<template>
    <vue-custom-scrollbar class="user-settings">
        <div class="inner">
            <div class="top" v-if="profile.id">
                <div id="add-pics" class="user-box" v-if="isMobile"
                    @click.prevent="goTo('/profile/edit')"
                    :class="{'online': !discreetModeEnabled,'meet_now': meetNowStatus}">
                    <div class="img" :style="{'background': `url(${defaultPhoto}) no-repeat center / cover`}"></div>
                    <div class="edit"></div>
                </div>
                <div id="add-pics" class="user-box" v-else
                    @click.prevent="openProfileEdit"
                    :class="{'online': !discreetModeEnabled,'meet_now': meetNowStatus}">
                    <div class="img" :style="{'background': `url(${defaultPhoto}) no-repeat center / cover`}"></div>
                    <div class="edit"></div>
                </div>
                <div class="buttons">
                    <div dusk="meet-now" id="meet_now"
                         class="button meet_now"
                         :class="{'active': meetNowStatus}"
                         @click="toggleMeetNow">
                        <span>{{meet_now_text}}</span>
                    </div>
                    <div class="button mask" id="mask-mode"
                        :class="{'active': discreetModeEnabled}"
                        @click="trySwitchDiscreetMode">
                        <span>{{ trans('discreet_mode') }}</span>
                    </div>
                </div>
            </div>
            <div class="profile-edit">
              <div class="box">
                <div class="name-edit notranslate">
                  <input
                      v-model="profile.headline"
                      type="text"
                      name="headline"
                      class="form-control"
                      :placeholder="trans('headline_or_nickname')"
                      v-bind:data-vv-as="trans('display_name')"
                      v-validate="{required: true, min: 3, max: 32}"
                      @change="saveProfileChange"
                  >
                </div>
                <span class="form-error" :class="{'is-visible': errors.has('headline')}">
                  {{ errors.first('headline') }}
                </span>
              </div>
                <router-link class="btn" :to="`/profile/edit`" v-if="isMobile">
                    <span>{{ 'Edit Profile' || trans('edit_profile') }}</span>
                </router-link>
                <a id="edit-profile-menu" class="btn" v-else
                    @click.prevent="openProfileEdit">
                    {{ 'Edit Profile' || trans('edit_profile') }}
                </a>
            </div>
            <div class="menu">
                <ul>
                    <li class="location notranslate">
                        <router-link class="profile-menu-item_link" v-if="isMobile"
                            :to="'/profile/location'">
                            <span class="menu-item-button location"></span>
                            <span class="menu-item-label">{{ this.profile.address || trans('location') }}</span>
                        </router-link>
                        <a class="profile-menu-item_link" v-else
                            @click.prevent="openProfileLocation">
                            <span class="menu-item-button location"></span>
                            <span class="menu-item-label">{{ this.profile.address || trans('location') }}</span>
                        </a>
                        <span class="location-refresh"
                            @click="forceUpdateLocation">
                            <i class="refresh" v-show="!locationUpdating"></i>
                            <img v-show="locationUpdating" class="preloader"
                                src="/assets/img/preloader.svg"
                                alt="">
                        </span>
                    </li>
                    <li>
                        <router-link class="profile-menu-item_link" v-if="isMobile"
                            :to="'/profile/photos'">
                            <span class="menu-item-button photos"></span>
                            <span class="menu-item-label">{{ trans('photos') }}</span>
                        </router-link>
                        <a class="profile-menu-item_link" v-else
                            @click.prevent="openProfilePhotos">
                            <span class="menu-item-button photos"></span>
                            <span class="menu-item-label">{{ trans('photos') }}</span>
                        </a>
                    </li>
                    <li>
                        <router-link class="profile-menu-item_link" v-if="isMobile"
                            :to="'/profile/videos'">
                            <span class="menu-item-button videos"></span>
                            <span class="menu-item-label">{{ trans('videos') }}</span>
                        </router-link>
                        <a class="profile-menu-item_link" v-else
                            @click.prevent="openProfileVideos">
                            <span class="menu-item-button videos"></span>
                            <span class="menu-item-label">{{ trans('videos') }}</span>
                        </a>
                    </li>
                    <li>
                        <router-link class="profile-menu-item_link" v-if="isMobile"
                            :to="'/profile/settings'">
                            <span class="menu-item-button settings"></span>
                            <span class="menu-item-label">{{ trans('settings') }}</span>
                        </router-link>
                        <a class="profile-menu-item_link" v-else
                            @click.prevent="openProfileSettings">
                            <span class="menu-item-button settings"></span>
                            <span class="menu-item-label">{{ trans('settings') }}</span>
                        </a>
                    </li>
                    <li :class="{'pro' : !userIsPro}">
                        <div class="profile-menu-item_link" @click="goPro">
                            <span class="menu-item-button" :class="{'pro' : userIsPro, 'non-pro' : !userIsPro}"></span>
                            <span class="menu-item-label">{{ userIsPro ? trans('pro') : trans('upgrade_to_pro') }}</span>
                        </div>
                    </li>
                    <li>
                        <router-link class="profile-menu-item_link" v-if="isMobile"
                                     :to="'/profile/share'">
                          <span class="menu-item-button share"></span>
                          <span class="menu-item-label">{{ trans('share_buddy_app') }}</span>
                        </router-link>
                        <a class="profile-menu-item_link" v-else
                           @click.prevent="openProfileShare">
                          <span class="menu-item-button share"></span>
                          <span class="menu-item-label">{{ trans('share_buddy_app') }}</span>
                        </a>
                    </li>
                    <li>
                        <router-link class="profile-menu-item_link" v-if="isMobile"
                            :to="'/profile/help'">
                            <span class="menu-item-button help"></span>
                            <span class="menu-item-label">{{ trans('help') }}</span>
                        </router-link>
                        <a class="profile-menu-item_link" v-else
                            @click.prevent="openProfileHelp">
                            <span class="menu-item-button help"></span>
                            <span class="menu-item-label">{{ trans('help') }}</span>
                        </a>
                    </li>
                    <li>
                        <a class="profile-menu-item_link"
                            @click="logout">
                            <span class="menu-item-button logout"></span>
                            <span class="menu-item-label">{{ trans('logout') }}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex';

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        props: ['tab'],
        mixins: [
            require('@general/lib/mixin').default
        ],
        data() {
            return {
              now : Date.now()
            }
        },
        components: {
          vueCustomScrollbar
        },
        created() {
          let self = this;
          setInterval(function () {
            if(self.meetNowStatus){
              self.now = Date.now()
            }
          }, 1000)
        },
      methods: {
            ...mapActions([
                'trySwitchDiscreetMode',
                'forceUpdateLocation',
                'openProfileEdit',
                'openProfileLocation',
                'openProfilePhotos',
                'openProfileVideos',
                'openProfileSettings',
                'openProfileShare',
                'openModeration',
                'openProfileHelp',
                'closeAllProfilePages',
                'toggleMeetNow'
            ]),
            goPro() {
              let value = !this.sidebar.profile.visible
              this.$store.dispatch('updateSidebarVisibility', {index: 'profile', value})
              this.closeAllProfilePages()
              this.goTo('/profile/pro')
            }
        },
        computed: {
            ...mapGetters([
                'discreetModeEnabled',
                'meetNowStatus'
            ]),
            ...mapState([
                'userIsPro',
                'profilePhotos',
                'profile',
                'locationUpdating',
                'sidebar'
            ]),
            meet_now_text(){
              if(this.meetNowStatus){
                var duration = moment.duration(moment(this.meetNowStatus.expire_at).diff(moment(this.now)));
                var minutes = duration.asMinutes();
                var minutes_string = parseInt(minutes.toString()) + 1;
                return (minutes_string <= window.MEET_NOW_ACTIVE_MIN ? minutes_string : window.MEET_NOW_ACTIVE_MIN) + ' min';
              }else{
                return this.trans('now');
              }
            },
            defaultPhoto() {
                let avatars = this.profile.avatars
                if (!avatars.adult && (avatars.default?.rejected || avatars.default?.pending)) {
                  return '/assets/img/default_180x180.jpg';
                } else {
                  return _.get(avatars, 'merged.photo_small', '/assets/img/default_180x180.jpg')
                }
            }
        }
    }
</script>
<style lang="scss">
.pro {
  .profile-menu-item_link {
    align-items: center !important;
    cursor: pointer;
  }
}
</style>